<div class="container-fluid nb-paginator">
  <div class="row">
    <div class="col-6 offset-3 text-center">
      <ngb-pagination *ngIf="state"
        class="nb-paginator-step"
        [page]="state.page"
        [pageSize]="state.limit"
        [collectionSize]="state.maxResults"
        (pageChange)="onChangePage($event)"
        [ellipses]="true"
        [maxSize]="5"
        [boundaryLinks]="true"></ngb-pagination>
    </div>
    <div class="col-3">
      <div *ngIf="state" class="form-group row">
        <select class="form-control col-6"
          [(ngModel)]="state.limit"
          (change)="onChangeLimit(state.limit)">
          <option *ngFor="let pageSize of pageSizes">{{ pageSize }}</option>
        </select>
        <label class="col-6 col-form-label">
          von {{ state.maxResults }} Ergebnissen
        </label>
      </div>
    </div>
  </div>
</div>
